//#region src/modules/ServicePeriods/activity-evals/instance/instance-eval-wire.ts
function fromAbsoluteWindow(window) {
	return {
		acceptEndsAt: window.acceptEndsAt,
		acceptStartsAt: window.acceptStartsAt,
		endsAt: window.endsAt,
		startsAt: window.startsAt,
		...window.bufferAfterMinutes ? { bufferAfterMinutes: window.bufferAfterMinutes } : {},
		...window.bufferBeforeMinutes ? { bufferBeforeMinutes: window.bufferBeforeMinutes } : {},
		...window.id ? { id: window.id } : {},
		...window.name ? { name: window.name } : {}
	};
}
function fromInstanceActivityEvalEnvelopeWire(raw) {
	return {
		dataType: raw.dataType,
		occurrence: raw.occurrence,
		window: fromAbsoluteWindow(raw.window),
		...raw.id ? { id: raw.id } : {},
		...raw.scopes ? { scopes: raw.scopes } : {}
	};
}
function fromActivityEvalRuntimeWire(raw) {
	return {
		dataType: raw.dataType,
		occurrence: raw.occurrence,
		status: raw.status,
		statusSummary: {
			fulfilled: raw.statusSummary.fulfilled,
			total: raw.statusSummary.total
		},
		window: fromAbsoluteWindow(raw.window),
		...raw.id ? { id: raw.id } : {},
		...raw.sourceRefScopes ? { scopes: raw.sourceRefScopes } : {},
		...raw.statusTimestamp ? { statusTimestamp: raw.statusTimestamp } : {}
	};
}
//#endregion
export { fromActivityEvalRuntimeWire, fromInstanceActivityEvalEnvelopeWire };

//# sourceMappingURL=instance-eval-wire.js.map